jQuery(document).ready(function( $ ) {

	// initiate tabs layout
	$( "#tabs" ).tabs();

	// initiate aos.js
	AOS.init();

	// bugfix: issues when swiperJS and aos.js are used on one page
	const numberedSliderElem = $('#numbered-slider');

	if ( numberedSliderElem.length ) {
		$(window).scroll(function() {
			if ( $(this).scrollTop() >= numberedSliderElem.position().top ) {
				AOS.init();
			}
		});
	}

	// mobile menu
	const mobileToggle = $('.toggle-menu');
	const navigationBar = $('.primary-navigation');

	mobileToggle.on('click', function () {

		mobileToggle.toggleClass('active');
		navigationBar.toggleClass('active');

	})

	// submit form trigger form on radio button click..
	$('#form-trigger input[type=radio]').on('change', function() {
		$(this).closest("form").submit();
	});


	let swiper = new Swiper(".news-slider", {
		slidesPerView: 1,
		spaceBetween: 30,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			1220: {
				slidesPerView: 3
			}
		}
	});

	let ticker = new Swiper(".ticker-slider", {
		speed: 6000,
		spaceBetween: 0,
		loop: true,
		autoplay: {
			delay: 1,
			disableOnInteraction: false
		}
	});

	let numberedSlider = new Swiper(".numbered-slider-swiper", {
		loop: true,
		spaceBetween: 20,
		slidesPerView: 1.8,
		slidesOffsetBefore: 20,
		roundLengths: true,
		slideToClickedSlide: true,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesOffsetBefore: 0,
				slidesPerView: 3,
			},
			1220: {
				slidesPerView: 5,
			}
		}
	});

	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
		anchor.addEventListener('click', function (e) {
			e.preventDefault();

			document.querySelector(this.getAttribute('href')).scrollIntoView({
				behavior: 'smooth'
			});
		});
	});

});
